<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M7.03125 3.125V5.46875M17.9688 3.125V5.46875M3.125 19.5312V7.8125C3.125 6.51808 4.17433 5.46875 5.46875 5.46875H19.5312C20.8257 5.46875 21.875 6.51808 21.875 7.8125V19.5312M3.125 19.5312C3.125 20.8257 4.17433 21.875 5.46875 21.875H19.5312C20.8257 21.875 21.875 20.8257 21.875 19.5312M3.125 19.5312V11.7188C3.125 10.4243 4.17433 9.375 5.46875 9.375H19.5312C20.8257 9.375 21.875 10.4243 21.875 11.7188V19.5312M12.5 13.2812H12.5078V13.2891H12.5V13.2812ZM12.5 15.625H12.5078V15.6328H12.5V15.625ZM12.5 17.9688H12.5078V17.9766H12.5V17.9688ZM10.1562 15.625H10.1641V15.6328H10.1562V15.625ZM10.1562 17.9688H10.1641V17.9766H10.1562V17.9688ZM7.8125 15.625H7.82031V15.6328H7.8125V15.625ZM7.8125 17.9688H7.82031V17.9766H7.8125V17.9688ZM14.8438 13.2812H14.8516V13.2891H14.8438V13.2812ZM14.8438 15.625H14.8516V15.6328H14.8438V15.625ZM14.8438 17.9688H14.8516V17.9766H14.8438V17.9688ZM17.1875 13.2812H17.1953V13.2891H17.1875V13.2812ZM17.1875 15.625H17.1953V15.6328H17.1875V15.625Z"
				:stroke="color"
				stroke-width="1.5625"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgEvents',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
		isActive: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
